"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@nivo/core");

var _Chip = _interopRequireDefault(require("./Chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
const BasicTooltip = (0, _react.memo)(({
  id,
  value: _value,
  format,
  enableChip,
  color,
  renderContent
}) => {
  const theme = (0, _core.useTheme)();
  const formatValue = (0, _core.useValueFormatter)(format);
  let content;

  if (typeof renderContent === 'function') {
    content = renderContent();
  } else {
    let value = _value;

    if (formatValue !== undefined && value !== undefined) {
      value = formatValue(value);
    }

    content = _react.default.createElement("div", {
      style: theme.tooltip.basic
    }, enableChip && _react.default.createElement(_Chip.default, {
      color: color,
      style: theme.tooltip.chip
    }), value !== undefined ? _react.default.createElement("span", null, id, ": ", _react.default.createElement("strong", null, isNaN(value) ? String(value) : value)) : id);
  }

  return _react.default.createElement("article", {
    className: "admin-tooltip"
  }, content);
});
BasicTooltip.displayName = 'BasicTooltip';
BasicTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes.default.node.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  enableChip: _propTypes.default.bool.isRequired,
  color: _propTypes.default.string,
  format: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  renderContent: _propTypes.default.func
} : {};
BasicTooltip.defaultProps = {
  enableChip: false
};
var _default = BasicTooltip;
exports.default = _default;
module.exports = exports.default;